module.exports = __webpack_public_path__ + "static/media/icon-modal-logo-discovery.e9ba748d.svg";